
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ViaAdministration, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ViaAdministrationEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    viaAdministration: ViaAdministration;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getViaAdministration()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getViaAdministration(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.viaAdministration = data;
                this.onDataChanged.next(this.viaAdministration);
                resolve(this.viaAdministration);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('viaAdministration/' + this.routeParams.id).subscribe((res: ViaAdministration ) => {
                    this.viaAdministration = res;
                    this.onDataChanged.next(this.viaAdministration);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(viaAdministration): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('viaAdministration/', viaAdministration).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(viaAdministration): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('viaAdministration/', viaAdministration).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(viaAdministration): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('viaAdministration/' + viaAdministration.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): ViaAdministration {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
